import { publicBasePaths, publicRequestPath } from './public-auth.js';
export function publicModuleBase(module, input) {
    if (!publicBasePaths.includes(`/${module}`))
        throw new Error('invalid_public_module');
    const base = input === undefined || input === '' ? '/' : input;
    if (base !== '/' && base !== `/${module}/`)
        throw new Error('invalid_public_module_base');
    return base;
}
export function publicStorageKey(module, base, legacy) {
    return publicModuleBase(module, base) === '/'
        ? legacy
        : `${legacy}:${module}`;
}
export function publicModuleApiMatch(module, base, url, origin, localPrefix) {
    const trailingSlash = localPrefix.endsWith('/') ? '/' : '';
    const path = publicRequestPath(publicModuleBase(module, base), trailingSlash ? localPrefix.slice(0, -1) : localPrefix);
    return url.origin === origin && url.pathname.startsWith(path + trailingSlash);
}
export function publicBaseArtifact(module, base) {
    const validated = publicModuleBase(module, base);
    return {
        name: 'sad5-public-base',
        generateBundle() {
            this.emitFile({
                type: 'asset',
                fileName: 'sad5-public-base.json',
                source: JSON.stringify({ schema: 1, module, base: validated }) + '\n',
            });
        },
    };
}
